export const useVerifyUserMutation = () => {
  const trigger = async (payload) => {
    const response = {
      data: {
        message: 'Verification successful (static mode)',
        user: {
          id: 1,
          name: 'Demo',
          family: 'User',
        },
      },
    };
    return response;
  };

  return [trigger, { data: null, error: null, isError: false, isSuccess: false, isLoading: false }];
};
